<template>
  <div class="flex space-x-2 items-stretch">
    <button
        v-for="tab in tabs"
        :key="tab.id"
        type="button"
        @click="selectTab(tab.id)"
        class="px-4 py-2 rounded transition-colors duration-300 flex items-center font-semibold"
        :class="{
        'bg-orange-300 text-orange-900': selectedTab === tab.id,
        'hover:bg-gray-200': selectedTab !== tab.id,
      }"
    >
      <Icon :iconType="tab.iconType" v-if="tab.iconType" class="mr-1" />
      <span class="flex flex-col items-start leading-tight">
        <span>{{ tab.label }}</span>
        <span v-if="tab.subtitle" class="text-xs font-normal opacity-70">{{ tab.subtitle }}</span>
        <span
            v-else-if="anyHasSubtitle"
            class="text-xs font-normal opacity-0 select-none"
            aria-hidden="true"
        >&nbsp;</span>
      </span>
      <!-- Count badge RIGHT side, styled like a professional tag -->
      <span
          v-if="tab.stats && typeof tab.stats.count === 'number'"
          class="ml-3 px-2 min-w-[1.8rem] h-6 flex items-center justify-center rounded-full bg-gray-100 text-orange-700 border border-orange-200 text-xs font-semibold shadow-sm"
          style="line-height:1.1;"
      >
        {{ tab.stats.count }}
      </span>
    </button>
  </div>
</template>


<script>
import Icon from "./Icon.vue";

export default {
  components: {
    Icon,
  },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    selectedTab: {
      type: String,
      required: true,
    },
  },
  computed: {
    anyHasSubtitle() {
      return Array.isArray(this.tabs) && this.tabs.some(t => t && t.subtitle);
    },
  },
  methods: {
    selectTab(tabId) {
      this.$emit("tab-selected", tabId);
    },
  },
};
</script>
